// Module
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import DatePicker from "react-datepicker";
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';

// CSS
import '_Asset/css/User/Page/connect.css';

// API
import { CoListApi } from '_Route/Api';
import { Pagination, PostList } from 'User/Component';
import { useRef } from 'react';


const Conference = () => {

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate()
  const sanitizer = DOMPurify.sanitize;
  const postGroupRef = useRef(null);
  const imgHost = process.env.REACT_APP_IMG_HOST;
  
  let heightArr = [];

  // 검색 및 페이징 API 호출
  const [searchInfo, setSearchInfo] = useState([]); // Search Result Paging Data
  const [searchRes, setSearchRes] = useState([]); // Search Result Data
  const [loading, setLoading] = useState(false);
  
   // const [searchTitle, setSearchTitle] = useState();
   const [curPage, setCurPage] = useState(1);
   const blockSize = 10;

  // 필터 옵션
  const [filterOpt, setFilterOpt] = useState({
    conference_title: '',
    conference_last_modify_date: '',
    conference_start_date: '',
    conference_last_date: new Date(),
    conference_category: '',
    curPage: curPage,
    pageSize: 10,
    blockSize: blockSize,
  })
  const { conference_title, conference_last_modify_date, conference_start_date, conference_last_date, conference_category, pageSize } = filterOpt;

 
  /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onFilter = (e) => {
    const { name, value } = e.target;
    setFilterOpt({...filterOpt, [name]: value});
  }

  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/connect/conference${conference_title === '' ? '' : '/' + encodeURIComponent(conference_title)}`);
  }


  /* ========================================================================
  * Axios Conference
  ========================================================================*/
  useEffect(() => {
    // setLoading(false)
    axios({
      method: 'GET',
      url: CoListApi,
      params: filterOpt,
    })
    .then(res => {
      // console.log(res, "Conference List GET Success!")
      setSearchInfo(res.data.pageInfo);
      setSearchRes(res.data.result);
    })
    .catch(err => {
      console.error(err, "Conference List GET Error...")
    })
    .finally(() => {
      setLoading(true);
    })
  }, [location, curPage, pageSize, conference_last_modify_date, conference_start_date, conference_last_date, conference_category])


  // const Skeleton = ({num}) => {
  //   const result = [];

  //   for (let i = 0; i < num; i++) {
  //     result.push(
  //       <Link key={i} to="/" className="coItem skeleton">
  //         <div className="contGroup">
  //           <h2>금융위 가이드 라인에 따른 NFT 조각판매 기준 발표</h2>

  //           <div className="subTxtGroup">
  //             <p>페이게이트 정기 세미나</p>
  //             <span>July 25, 2022</span>
  //           </div>

  //           <p className="coCont">
  //             "금융위 가이드라인에 따른 디지털 자산과 조각거래"라는 제목으로 개최된 이번 세미나에서는 온투업 및 월렛서비스 관련 현황 등에 대한 내용과 페이게이트의 세이퍼트 시스템의 개선 작업 진행 상황에 대한 보고, 민간거래소 ARX와 NFT 플랫폼 구축 상황 등에 대한 주제 발표가 진행되었다."금융위 가이드라인에 따른 디지털 자산과 조각거래"라는 제목으로 개최된 이번 세미나에서는 온투업 및 월렛서비스 관련 현황 등에 대한 내용과
  //           </p>
  //         </div>

  //         <p className="coImgBox"></p>
  //       </Link>
  //     )
  //   }
  //   return result;
  // }
  // Skeleton Component

  const Skeleton = ({num}) => {
    const result = [];

    for (let i = 0; i < num; i++) {
      result.push(
        <div key={i} className="postItem skeleton" >
          <p className="imgBox"></p>

          <div className="postInner">
            <div className="category">
              <p>category</p>
              <span>tag</span>
            </div>
            
            <div className="postTxtGroup">
              <strong>출금 장애 및 해소 안내드립니다.</strong>
              <p>페이게이트 입니다. 세이퍼트 API 중 조회 조건 없이 하위 멤버를 조회하는 allInfo 기능에 부하가 과하여 검색 조건 없이 조회를 할 경우 업체의 정보만</p>
            </div>

            <div className="registInfo">
              <p>Admin</p>
              <span>July 8, 2022</span>
            </div>
          </div>
        </div>
      )
    }
    return result;
  }


  return (
    <>
      {/* Visual */}
      <div className="visual connect">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">Conference</h2>
            
            <p className="visualTxt">Get the latest updates and announcements.</p>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="newsArea areaBox">

            <div className="flexBox search">
              <fieldset>
                <legend>콘텐츠 검색</legend>

                <div className="fieldGroup row">
                  <div className="field gap">
                    <input type="input" name="conference_title" className="input md round_10" onChange={(e) => onFilter(e)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                    <button type="button" className="btn sm round_10 sfrtBlue" onClick={onSearch}>검색</button>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="flexBox between end">
              <fieldset className="row">
                <div className="fieldGroup">
                  <label className="sm">수정 날짜</label>

                  <div className="field">
                    <select name="conference_last_modify_date" className="select sm type_1 round_10" onChange={(e) => onFilter(e)}>
                      <option value="">모든 기간</option>
                      <option value="day">하루 전</option>
                      <option value="week">일주일 전</option>
                      <option value="month">한달 전</option>
                      <option value="year">일년 전</option>
                    </select>
                  </div>
                </div>

                <div className="fieldGroup">
                  <label className="sm">기간 선택</label>

                  <div className="field gap">
                    <div className="inputIco">
                      <DatePicker
                        className="input sm round_10 i_rt"
                        // showTimeSelect
                        selected={conference_start_date}
                        onChange={date => setFilterOpt({...filterOpt, conference_start_date: date})}
                        dateFormat="yyyy.MM.dd"
                        maxDate={new Date(conference_last_date)}
                      />
                      <i className="icofont-calendar"></i>
                    </div>

                    <span>~</span>

                    <div className="inputIco">
                      <DatePicker
                        className="input sm round_10 i_rt"
                        // showTimeSelect
                        selected={conference_last_date}
                        onChange={date => setFilterOpt({...filterOpt, conference_last_date: date})}
                        dateFormat="yyyy.MM.dd"
                        minDate={new Date(conference_start_date)}
                        maxDate={new Date()}
                      />
                      <i className="icofont-calendar"></i>
                    </div>
                  </div>
                </div>

                <div className="fieldGroup">
                  <label className="sm">카테고리</label>

                  <div className="field">
                    <select name="conference_category" className="select sm type_1 round_10" onChange={(e) => onFilter(e)}>
                      <option value="">모두</option>
                      <option value="news">NEWS</option>
                      <option value="notice">NOTICE</option>
                    </select>
                  </div>
                </div>
              </fieldset>
              
              <div className="fieldGroup row gap">
                <label>게시물 수</label>

                <div className="field">
                  <select name="pageSize" className="select type_1 round_10 sm" onChange={(e) => onFilter(e)} defaultValue="30">
                    <option value="10">10개 씩</option>
                    <option value="30">30개 씩</option>
                    <option value="50">50개 씩</option>
                    <option value="100">100개 씩</option>
                  </select>
                </div>
              </div>
            </div>

            {
              loading ?
                searchRes.length !== 0 ?
                <>
                  <div className="postGroup" ref={postGroupRef}>
                    {searchRes.map((data, i) =>
                      <PostList item={data} index={i} key={i} heightArr={heightArr} type='conference' ref={postGroupRef} />
                      
                      // <Link key={i} to={`/connect/conference/${item.conference_uuid}`} className="coItem">
                      //   <div className="contGroup">
                      //     <h2>{item.conference_title}<i className="icofont-rounded-right"></i></h2>

                      //     <div className="subTxtGroup">
                      //       <p>{item.conference_cat}</p>
                      //       <span>{FormatConv(item.conference_create_date)}</span>
                      //     </div>

                      //     <p className="coCont" dangerouslySetInnerHTML={{ __html: sanitizer(item.conference_content)}}></p>
                      //   </div>

                      //   <p className="coImgBox">
                      //     <img src={item.conference_file ? `${imgHost}/${JSON.parse(item.conference_file)[0]}` : require('_Asset/img/blockchain_video.jpg')} alt=""/>
                      //   </p>
                      // </Link>
                    )}
                  </div>

                  <div className="flexBox center">
                    <Pagination
                      type="type_2"
                      size="lg"
                      curPage={curPage}
                      setCurPage={setCurPage}
                      pageSize={pageSize}
                      blockSize={blockSize}
                      startBlock={searchInfo.startBlock}
                      endBlock={searchInfo.endBlock}
                      pageCount={searchInfo.pageCount}
                    />
                  </div>
                </>
                :
                <div className="noDataBox">
                  <i className="icofont-warning-alt"></i>
                  <p>No results found for <span>{params.key}</span>.<br /> Please enter another search term.</p>
                </div>
              :
              <div className="postGroup">
                <Skeleton num={9} />
              </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default Conference;